export enum ClassState {
  New = 0,
  Running = 1,
  Completed = 2,
}
